<template>
    <div>

        <div :class="view_class_view.div_container">
            <div>
                <label :class="view_class_view.label_type_housing" for="select_type_housing"> Tipo de vivienda:</label>
                <select id="select_type_housing" 
                    v-model="housingInfoModel.type"
                    v-bind:class="{[ view_class_view.classInputs.default + view_class_view.classInputs.no_valid ]: housingInfoModelValidation.type.$error,
                    [view_class_view.classInputs.default + view_class_view.classInputs.valid]:!housingInfoModelValidation.type.$invalid,
                    [view_class_view.classInputs.default ]: housingInfoModelValidation.type.$invalid && !housingInfoModelValidation.type.$error  }"
                    @blur="housingInfoModelValidation.type.$validate">
                    <option value="seleccionar" selected hidden>Seleccione un tipo de vivienda</option>
                    <option :value="item.value" v-for="(item, i) in housingTypes" :key="i">{{item.text}}</option>
                </select>

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of housingInfoModelValidation.type.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>

            <div>
                <label :class="view_class_view.label_start_residency" for="select_start_residency"> Inicio de Residencia: </label>
                <DatePicker   
                    editable
                    format='DD/MM/YYYY'
                    @change="select_date_residency($event)"
                    simple
                    color="#810042"
                    locale="es"
                        :localeConfig="{
                            es: {
                                displayFormat: 'DD/MM/YYYY',
                                lang: {
                                    year: 'Año',
                                    month: 'Mes',
                                    day: 'Día',
                                    label: '',
                                    submit: 'Seleccionar',
                                    cancel: 'Cancelar',
                                    now: 'Hoy',
                                    nextMonth: 'Siguiente',
                                    prevMonth: 'Anterior',
                                },
                            }
                        }"
                />

                <div :class="view_class_view.div_container_error.container" v-for="(error,index) of housingInfoModelValidation.startOfResidency.$errors" :key="index">
                    <div :class="view_class_view.div_container_error.text_error">{{ error.$message }}</div>
                </div>
            </div>
        </div>



    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { ref } from 'vue';
import moment from "moment";
export default({
    name:"HousingInfo",
    props:{
        view_class_view:{},
        validations:{}
        
    },
    setup(props){

        const housingInfoModel = ref({ type: '', startOfResidency: ''});
        const housingInfoModelValidation = useVuelidate(props.validations,housingInfoModel);
        const housingTypes = [
            {value: 'propia', text: 'Propia'},
            {value: 'rentada', text: 'Rentada'},
            {value: 'pagandola', text: 'Pagandola'},
            {value: 'con familiares', text: 'Con Familiares'},
            {value: 'prestada', text: 'Prestada'},
        ];

        function select_date_residency(value){
            housingInfoModel.value.startOfResidency = moment(value._d).format("DD-MM-YYYY");            
        }

        function execute_validation(){
            housingInfoModelValidation.value.$validate();

            if(housingInfoModelValidation.value.$error){
                return false;
            }

            return housingInfoModel.value;
        }

        return {
            housingInfoModel,
            housingInfoModelValidation,
            housingTypes,
            select_date_residency,
            execute_validation
        }

    }
});
</script>